module.exports = [
	{
		"kw": 0.00122,
		"appliances": {
			"kitchen": {
				"total_kw": 0.21,
				"room": "kitchen"
			}
		},
		"hour": 0
	},
	{
		"kw": 0.00127,
		"appliances": {
			"kitchen": {
				"total_kw": 0.21,
				"room": "kitchen"
			}
		},
		"hour": 1
	},
	{
		"kw": 0.00128,
		"appliances": {
			"kitchen": {
				"total_kw": 0.21,
				"room": "kitchen"
			}
		},
		"hour": 2
	},
	{
		"kw": 0.00126,
		"appliances": {
			"kitchen": {
				"total_kw": 0.21,
				"room": "kitchen"
			}
		},
		"hour": 3
	},
	{
		"kw": 0.00123,
		"appliances": {
			"kitchen": {
				"total_kw": 0.21,
				"room": "kitchen"
			}
		},
		"hour": 4
	},
	{
		"kw": 0.00122,
		"appliances": {
			"kitchen": {
				"total_kw": 0.21,
				"room": "kitchen"
			}
		},
		"hour": 5
	},
	{
		"kw": 0.00169,
		"appliances": {
			"kitchen": {
				"total_kw": 0.21,
				"room": "kitchen"
			}
		},
		"hour": 6
	},
	{
		"kw": 0.02198,
		"appliances": {
			"kitchen": {
				"total_kw": 3.0600000000000005,
				"room": "kitchen"
			}
		},
		"hour": 7
	},
	{
		"kw": 0.4261,
		"appliances": {
			"kitchen": {
				"total_kw": 0.21,
				"room": "kitchen"
			}
		},
		"hour": 8
	},
	{
		"kw": 0.66226,
		"appliances": {
			"kitchen": {
				"total_kw": 0.21,
				"room": "kitchen"
			}
		},
		"hour": 9
	},
	{
		"kw": 0.84412,
		"appliances": {
			"livingroom": {
				"total_kw": 1.1,
				"room": "livingroom"
			},
			"kitchen": {
				"total_kw": 1.81,
				"room": "kitchen"
			}
		},
		"hour": 10
	},
	{
		"kw": 0.97199,
		"appliances": {
			"livingroom": {
				"total_kw": 1.1,
				"room": "livingroom"
			},
			"kitchen": {
				"total_kw": 1.81,
				"room": "kitchen"
			}
		},
		"hour": 11
	},
	{
		"kw": 1.02727,
		"appliances": {
			"livingroom": {
				"total_kw": 1.1,
				"room": "livingroom"
			},
			"kitchen": {
				"total_kw": 1.81,
				"room": "kitchen"
			}
		},
		"hour": 12
	},
	{
		"kw": 1.00772,
		"appliances": {
			"study": {
				"total_kw": 2.3,
				"room": "study"
			},
			"kitchen": {
				"total_kw": 0.21,
				"room": "kitchen"
			}
		},
		"hour": 13
	},
	{
		"kw": 0.90481,
		"appliances": {
			"bathroom": {
				"total_kw": 0.9,
				"room": "bathroom"
			},
			"study": {
				"total_kw": 2.3,
				"room": "study"
			},
			"kitchen": {
				"total_kw": 2.61,
				"room": "kitchen"
			}
		},
		"hour": 14
	},
	{
		"kw": 0.73891,
		"appliances": {
			"bathroom": {
				"total_kw": 1.9,
				"room": "bathroom"
			},
			"livingroom": {
				"total_kw": 0.1,
				"room": "livingroom"
			},
			"study": {
				"total_kw": 2.3,
				"room": "study"
			},
			"kitchen": {
				"total_kw": 2.61,
				"room": "kitchen"
			}
		},
		"hour": 15
	},
	{
		"kw": 0.52183,
		"appliances": {
			"bathroom": {
				"total_kw": 0.9,
				"room": "bathroom"
			},
			"livingroom": {
				"total_kw": 0.1,
				"room": "livingroom"
			},
			"study": {
				"total_kw": 2.75,
				"room": "study"
			},
			"kitchen": {
				"total_kw": 2.61,
				"room": "kitchen"
			}
		},
		"hour": 16
	},
	{
		"kw": 0.27359,
		"appliances": {
			"study": {
				"total_kw": 2.75,
				"room": "study"
			},
			"bedroom": {
				"total_kw": 0.05,
				"room": "bedroom"
			},
			"livingroom": {
				"total_kw": 0.1,
				"room": "livingroom"
			},
			"kitchen": {
				"total_kw": 0.21,
				"room": "kitchen"
			}
		},
		"hour": 17
	},
	{
		"kw": 0.01381,
		"appliances": {
			"study": {
				"total_kw": 2.75,
				"room": "study"
			},
			"bedroom": {
				"total_kw": 0.05,
				"room": "bedroom"
			},
			"livingroom": {
				"total_kw": 1.4000000000000001,
				"room": "livingroom"
			},
			"kitchen": {
				"total_kw": 0.21,
				"room": "kitchen"
			}
		},
		"hour": 18
	},
	{
		"kw": 0.00124,
		"appliances": {
			"study": {
				"total_kw": 0.45,
				"room": "study"
			},
			"bedroom": {
				"total_kw": 0.05,
				"room": "bedroom"
			},
			"livingroom": {
				"total_kw": 1.3,
				"room": "livingroom"
			},
			"kitchen": {
				"total_kw": 1.51,
				"room": "kitchen"
			}
		},
		"hour": 19
	},
	{
		"kw": 0.00122,
		"appliances": {
			"study": {
				"total_kw": 0.495,
				"room": "study"
			},
			"bedroom": {
				"total_kw": 0.05,
				"room": "bedroom"
			},
			"livingroom": {
				"total_kw": 0.4,
				"room": "livingroom"
			},
			"kitchen": {
				"total_kw": 1.51,
				"room": "kitchen"
			}
		},
		"hour": 20
	},
	{
		"kw": 0.00123,
		"appliances": {
			"study": {
				"total_kw": 0.045,
				"room": "study"
			},
			"livingroom": {
				"total_kw": 0.4,
				"room": "livingroom"
			},
			"kitchen": {
				"total_kw": 0.21,
				"room": "kitchen"
			}
		},
		"hour": 21
	},
	{
		"kw": 0.0012,
		"appliances": {
			"study": {
				"total_kw": 0.045,
				"room": "study"
			},
			"livingroom": {
				"total_kw": 0.4,
				"room": "livingroom"
			},
			"kitchen": {
				"total_kw": 0.21,
				"room": "kitchen"
			}
		},
		"hour": 22
	},
	{
		"kw": 0.00123,
		"appliances": {
			"kitchen": {
				"total_kw": 0.21,
				"room": "kitchen"
			}
		},
		"hour": 23
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data.json
// module id = 105
// module chunks = 0